import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MobileVideoControls = ({
  isMuted,
  isCameraOff,
  isScreenSharing,
  onToggleMute,
  onToggleCamera,
  onToggleScreenShare,
  onEndCall,
  onToggleChat,
  onTogglePatientInfo,
  callDuration
}) => {
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins?.toString()?.padStart(2, '0')}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="md:hidden">
      {/* Top Status Bar */}
      <div className="absolute top-4 left-4 right-4 flex items-center justify-between z-20">
        <div className="bg-black/50 backdrop-blur-sm rounded-lg px-3 py-2">
          <div className="flex items-center space-x-2 text-white text-sm">
            <div className="w-2 h-2 bg-green-500 rounded-full" />
            <span>Connected • {formatDuration(callDuration)}</span>
          </div>
        </div>
        
        <Button
          variant="destructive"
          size="sm"
          iconName="AlertTriangle"
          iconPosition="left"
          className="bg-red-600 hover:bg-red-700"
        >
          Emergency
        </Button>
      </div>

      {/* Bottom Controls */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/80 backdrop-blur-sm p-4">
        {/* Main Controls */}
        <div className="flex items-center justify-center space-x-6 mb-4">
          <Button
            variant={isMuted ? "destructive" : "secondary"}
            size="icon"
            onClick={onToggleMute}
            className="w-14 h-14 rounded-full"
          >
            <Icon name={isMuted ? "MicOff" : "Mic"} size={24} />
          </Button>

          <Button
            variant={isCameraOff ? "destructive" : "secondary"}
            size="icon"
            onClick={onToggleCamera}
            className="w-14 h-14 rounded-full"
          >
            <Icon name={isCameraOff ? "VideoOff" : "Video"} size={24} />
          </Button>

          <Button
            variant="destructive"
            size="icon"
            onClick={onEndCall}
            className="w-16 h-16 rounded-full"
          >
            <Icon name="PhoneOff" size={24} />
          </Button>

          <Button
            variant={isScreenSharing ? "default" : "secondary"}
            size="icon"
            onClick={onToggleScreenShare}
            className="w-14 h-14 rounded-full"
          >
            <Icon name="Monitor" size={24} />
          </Button>
        </div>

        {/* Secondary Controls */}
        <div className="flex items-center justify-center space-x-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleChat}
            iconName="MessageSquare"
            iconPosition="left"
            className="text-white hover:bg-white/20"
          >
            Chat
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onTogglePatientInfo}
            iconName="User"
            iconPosition="left"
            className="text-white hover:bg-white/20"
          >
            Patient Info
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="FileText"
            iconPosition="left"
            className="text-white hover:bg-white/20"
          >
            Notes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileVideoControls;